import { Box, Typography } from "@mui/material";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { getImageForType } from "../../utils/cms.utils";
import ContentTag from "../../utils/tag";

const ContentRowScrollingWrapper = styled(Box)`
  overflow-x: auto;
  overflow-y: hidden;
  flex-shrink: 1;
  flex-grow: 1;
  width: 100%;
`;

const ContentRowScrollingContent = styled(Box)`
  width: 100%;
`;

const ContentRowWrapper = styled(Box)`
  position: relative;
  width: 100%;
`;

const ContentRowTitle = styled(Typography)`
  color: white;
  margin-bottom: 22px;
  font-size: 27px;
  font-weight: 700;
  margin-top: 1rem;
  padding-left: 60px;
`;

const MovieItem = ({ item = {}, onFocus }) => {
  const navigate = useNavigate();
  const { contentPhotos, slug, contentType, _id } = item;
  const { focused, ref } = useFocusable({
    onFocus,
    onEnterPress: () => {
      navigate(`/${contentType?.kind}/${slug}`);
    },
    focusKey: "content_" + _id,
  });

  return (
    <Box
      ref={ref}
      width={"270px"}
      minWidth={"215px"}
      minHeight={"350px"}
      p={2}
      mb={1}
    >
      <Box
        minHeight={"350px"}
        sx={{
          width: "100%",
          background: `url(${getImageForType("verticalCover", contentPhotos)})`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          boxShadow: focused
            ? "inset 0 0 0 4px #F5F5F5"
            : "inset 0 0 0 4px transparent",
          position: "relative",
          overflow: "hidden",
          zIndex: focused ? 10 : 0,
        }}
        onClick={() => navigate(`/${contentType?.kind}/${slug}`)}
        className="cursor-pointer rounded-2xl"
      >
        <ContentTag label={"آنلاین باخیش"} />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            opacity: focused ? 1 : 0,
            pointerEvents: "none",
            transition: "opacity 0.2s",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: "20px",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{
              color: "white",
              fontSize: "16px",
              fontWeight: 400,
              textAlign: "center",
            }}
          >
            {item.year}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export const CategoriesSlider = ({ movies, onFocus, rowTitle, id }) => {
  const { ref, focusKey } = useFocusable({
    focusKey: `cat_${id}`,
  });
  const navigate = useNavigate();
  return (
    <FocusContext.Provider value={focusKey}>
      <ContentRowWrapper ref={ref}>
        <ContentRowTitle>{rowTitle}</ContentRowTitle>
        <ContentRowScrollingWrapper>
          <ContentRowScrollingContent className="flex flex-wrap">
            {movies?.map((item) => (
              <MovieItem
                item={item}
                key={item._id}
                onEnterPress={() =>
                  navigate(`/${item.contentType.kind}/${item.slug}`)
                }
                onFocus={onFocus}
              />
            ))}
          </ContentRowScrollingContent>
        </ContentRowScrollingWrapper>
      </ContentRowWrapper>
    </FocusContext.Provider>
  );
};
